import { Skeleton } from "@/components/ui";

export const PatientBarSkeleton = () => {
  return (
    <div className="flex h-16 items-center justify-start gap-4 p-4">
      <Skeleton className="h-8 w-8 rounded-full" />
      <Skeleton className="h-6 w-40" />
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-16" />
      <Skeleton className="h-4 w-32" />
    </div>
  );
};
